const React = require("react");
const InitialLoadProvider = require("./src/context/InitialLoadContext")
  .InitialLoadProvider;
const ShopifyProvider = require("./src/context/ShopifyContext").ShopifyProvider;

exports.wrapRootElement = ({ element }) => {
  return (
    <InitialLoadProvider>
      <ShopifyProvider>{element}</ShopifyProvider>
    </InitialLoadProvider>
  );
};
